import { CantileverButton } from 'components/CantileverButton'
import { MousePointerClick, SplinePointer, ZoomIn } from 'lucide-react'
import React from 'react'

import {
  ButtonContainer,
  TooltipText,
  TooltipTitle,
  ViewHighlight,
  ViewTooltipBox,
  ViewTooltipColumn,
  ViewTooltipColumns,
  ViewTooltipContainer,
} from './TutorialStyledComponents'

interface ViewTooltipProps {
  onNext: () => void
  onPrevious: () => void
}

export const ViewTooltip: React.FC<ViewTooltipProps> = ({
  onNext,
  onPrevious,
}) => {
  return (
    <>
      <ViewHighlight />
      <ViewTooltipContainer>
        <ViewTooltipBox>
          <TooltipTitle>3D View</TooltipTitle>
          <TooltipText>
            This is your main 3D view where you can interact with the model. Use
            the controls you learned to navigate, zoom, and explore. You can
            right click directly on the model to create annotations or take
            measurements. Try it!
          </TooltipText>
          <ViewTooltipColumns>
            <ViewTooltipColumn>
              <MousePointerClick size={32} color='rgba(255, 255, 255, 0.9)' />
              <span>Double click to navigate</span>
            </ViewTooltipColumn>
            <ViewTooltipColumn>
              <SplinePointer size={32} color='rgba(255, 255, 255, 0.9)' />
              <span>Click and drag to orbit</span>
            </ViewTooltipColumn>
            <ViewTooltipColumn>
              <ZoomIn size={32} color='rgba(255, 255, 255, 0.9)' />
              <span>Scroll the mouse to zoom</span>
            </ViewTooltipColumn>
          </ViewTooltipColumns>
          <ButtonContainer>
            <CantileverButton onClick={onPrevious}>Previous</CantileverButton>
            <CantileverButton primary onClick={onNext}>
              Next
            </CantileverButton>
          </ButtonContainer>
        </ViewTooltipBox>
      </ViewTooltipContainer>
    </>
  )
}
